import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { POST_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { GlossaryResponse, CreateGlossaryRequest } from '@utils/types/glossary';

export const useCreateGlossary = () => {
  const queryClient = useQueryClient();

  const createGlossary = async (payload: CreateGlossaryRequest) => {
    const response = await Axios.post<GlossaryResponse>(
      POST_URL().createGlossary,
      payload
    );
    return response.data;
  };

  return useMutation<
    GlossaryResponse,
    AxiosError<BaseError>,
    CreateGlossaryRequest
  >(createGlossary, {
    onSuccess: () => {
      queryClient.invalidateQueries('glossaries');
    },
    useErrorBoundary: false
  });
};
